// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-promo-event__wrapper{background:no-repeat 50%/cover}.block-promo-event-wrapper:nth-child(2n) .block-promo-event__inner{flex-direction:row}.block-promo-event-wrapper:nth-child(odd) .block-promo-event__inner{flex-direction:row-reverse}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
